// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height[data-v-86b6313e] {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body[data-v-86b6313e] {\r\n  padding-top: 0px;\n}\n.el-tabs--card[data-v-86b6313e] {\r\n  height: calc(100vh - 200px);\r\n  /* overflow-y: auto; */\n}\n.el-tab-pane[data-v-86b6313e] {\r\n  height: calc(100vh - 200px);\r\n  overflow-y: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
